import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ScheduleSparkline } from "../settings/ScheduleSparkline";
import {
  ScheduleDataPoint,
  MixGroupScheduleRow,
  formatScheduleValue,
} from "./useTenantSchedule";

export const TenantScheduleDisplay = ({
  scheduledTons,
  formattedMonth,
  dataPoints,
  mixGroupNames,
  mixGroupDataPoints,
}: {
  scheduledTons: number;
  formattedMonth: string;
  dataPoints: ScheduleDataPoint[];
  mixGroupNames?: string[];
  mixGroupDataPoints?: MixGroupScheduleRow[];
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <ScheduleSparkline
        dataPoints={dataPoints}
        mixGroupNames={mixGroupNames}
        mixGroupDataPoints={mixGroupDataPoints}
      />
      <Stack alignItems="center" justifyContent="center">
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: theme.palette.data.pink,
          }}
        >
          {formatScheduleValue(scheduledTons)}
          {t("tonnesShort")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ({formattedMonth})
        </Typography>
      </Stack>
    </Stack>
  );
};
